import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as SingleAccess } from '../../images/icons/door-key-svgrepo-com.svg';
import clsx from 'clsx';

interface IProps extends StyledComponentProps {
    onClick: (evt:any) => any;
    disabled?: boolean;
    className?: any;
    title?: string;
}

const RemoveSingleAccessIconButton = (props: IProps) => {
    return (<MuiButton
        title={props.title}
        disabled={props.disabled}
        className={props.className ? clsx(props.className, props.classes.iconButtonRootSvgBlack) : props.classes.iconButtonRootSvgBlack}
        onClick={props.onClick}>
        <SingleAccess className={props.classes.iconButtonSvgBlack} />
    </MuiButton>)
}

export default withStyles(styles)(RemoveSingleAccessIconButton)